var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeller(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.73,
    y1: -8.344,
    x2: 2.122,
    y2: 7.027,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teller",
    transform: "translate(-992 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6103",
    "data-name": "Rectangle 6103",
    width: 24,
    height: 24,
    transform: "translate(992 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Teller-2",
    "data-name": "Teller",
    transform: "translate(994.091 57.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3258",
    "data-name": "Group 3258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3257",
    "data-name": "Group 3257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3256",
    "data-name": "Group 3256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M15.8,18.352V5.2h0V5.1a.711.711,0,0,0-.7-.8c-.5,0-.6.3-.6.8v13.45c0,.4.2.7.6.7.5,0,.6-.3.6-.7.2-.2.2-.2.1-.2Z",
    transform: "translate(-2.11 -3.089)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M12.137,3.1H4.609A2.442,2.442,0,0,0,2.2,5.509V9.323s-.1,7.929,0,11.643c0,1.2.6,1.405,2.409,1.3h7.327c2.108-.1,2.81,0,2.81-1.506V5.509A2.545,2.545,0,0,0,12.137,3.1Z",
    transform: "translate(-2.156 -3.094)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M20.216,7H15.9V17.037h4.918c.9,0,1.1-.2,1.1-1V8.807C21.922,6.9,21.822,7,20.216,7Z",
    transform: "translate(-2.104 -3.079)",
    fill: "#33eeb1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3259",
    "data-name": "Group 3259",
    transform: "translate(2.955 6.932)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 6.123,
    fill: "none",
    stroke: "#18253e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x2: 6.123,
    transform: "translate(0 4.718)",
    fill: "none",
    stroke: "#18253e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeller);
export default __webpack_public_path__ + "static/media/teller.83ac3b6f34809716a3d9c8971ed08472.svg";
export { ForwardRef as ReactComponent };